/**
 * Moves Wishlist Hero's product-page button from <product-form> onto the gallery (top-right).
 */
(() => {
  const WISHLIST_SELECTORS = [
    '#wishlisthero-product-page-button-container',
    '.wishlisthero-product-page-button-container',
  ].join(', ');

  const RELOCATE_DELAYS_MS = [0, 100, 350, 700, 1500, 3000];

  function findWishlistContainer(root) {
    if (!root) return null;
    return root.querySelector(WISHLIST_SELECTORS);
  }

  function relocateForGallery(gallery) {
    const anchor = gallery.querySelector('[data-product-gallery-wishlist]');
    if (!anchor) return;

    const formId = gallery.getAttribute('form');
    if (!formId) return;

    const form = document.forms[formId];
    if (!form) return;

    const productForm = form.closest('product-form');
    const source = findWishlistContainer(productForm) || findWishlistContainer(form);
    if (!source || source.parentElement === anchor) return;

    anchor.appendChild(source);
  }

  function relocateAll() {
    document.querySelectorAll('product-gallery[form]').forEach(relocateForGallery);
  }

  function scheduleRelocate() {
    RELOCATE_DELAYS_MS.forEach((delay) => {
      setTimeout(relocateAll, delay);
    });
  }

  function observeProductForms() {
    document.querySelectorAll('product-form').forEach((productForm) => {
      if (productForm.dataset.wishlistGalleryObserved === 'true') return;
      productForm.dataset.wishlistGalleryObserved = 'true';

      const observer = new MutationObserver(() => relocateAll());
      observer.observe(productForm, { childList: true, subtree: true });
    });
  }

  function init() {
    relocateAll();
    scheduleRelocate();
    observeProductForms();

    document.addEventListener('product:rerender', relocateAll);
    document.addEventListener('shopify:section:load', () => {
      observeProductForms();
      scheduleRelocate();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
